import { cn } from '@/util/cn';
import React from 'react';
import { AdUnit, AdUnitClasses } from '@/tracking/ads/components/AdUnit';
import { GPTAds } from '@/tracking/ads/GPTAds';
import { AdPositions } from '@/tracking/ads/types';
import { weSkiDestinationId } from '@/components/common/PlanYourTrip/WeSki/resolver';
import { WESKI_FLEXIBLE_OPTION } from '@/ots-constants';
import { getLocale } from '@/i18n/locale';
import { ELocale } from '@/i18n/localeEnum';
import { isResortWithoutWeSki } from '@/util/isResortWithoutWeSki';
import { isRegionWithoutWeSki } from '@/util/isRegionWithoutWeSki';
import WeSki from '@/components/common/PlanYourTrip/WeSki/WeSkiWidget';

interface IProps {
  id?: string;
  isRegion?:boolean;
  showWeSki?: boolean;
  showWeSkiOnMobileOnly?: boolean;
  hideWeSkiOnMobile?: boolean;
  isSummerMode?: boolean;
}

const getWeSkiDestinationId = (id: string, isRegion:boolean) => {
  const weDestinationId = (isRegion ? weSkiDestinationId({ regionId: id }) : weSkiDestinationId({ resortId: id })) ?? WESKI_FLEXIBLE_OPTION;

  return weDestinationId;
};

export const SidebarAd = ({
  id = '',
  isRegion = false,
  showWeSki = true,
  showWeSkiOnMobileOnly = false,
  hideWeSkiOnMobile = false,
  isSummerMode = false,
}: IProps) => {
  const locale = getLocale();
  const weSkiDestination = getWeSkiDestinationId(id, isRegion);
  const shouldHideWeSki = isResortWithoutWeSki(id, locale) || isRegionWithoutWeSki(id, locale);
  const shouldShowWeSki = showWeSki && locale !== ELocale.IT_IT && !shouldHideWeSki;

  return (
    <>
      <div className="static mb-5">
        <AdUnit
          generator={GPTAds[AdPositions.Skyscraper]}
          className={AdUnitClasses.sky}
          desktop
          mobile
          recreateOnTablet
        />
      </div>
      {shouldShowWeSki && !isSummerMode && (
        <div
          className={cn(
            'sticky top-5',
            showWeSkiOnMobileOnly && 'md:hidden',
            hideWeSkiOnMobile && 'max-md:hidden',
          )}
        >
          <WeSki destinationId={weSkiDestination} />
        </div>
      )}
    </>
  );
};
